import { xget } from "../Fetchv2";

export class CloudflareR2 {
	/** @GET /pages/:uid/ads
	 * Obtiene todos los anuncios de la página
	 */
	async getSignedUrl(key: string) {
		let response = await xget<{ url: string }>(`/upload-request`, { key });
		return response;
	}
}
